import { Component } from "@angular/core";
import { NotificationService } from "./notification.service";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class NotificationComponent {
  get showSavedSuccessMsg(): boolean {
    return this.notification.successMessageShown;
  }

  get showSavedErrorMsg(): boolean {
    return this.notification.errorMessageShown;
  }

  get error(): any {
    return this.notification.errorMessage;
  }

  constructor(private notification: NotificationService) { }

  closeSuccessMessage(): void {
    this.notification.hideSuccessMessage();
  }

  closeErrorMessage(): void {
    this.notification.hideErrorMessage();
  }
}
